const config = {
  development: {
    API_URL: process.env.REACT_APP_API_URL,
    AUTH_URL: process.env.REACT_APP_AUTH_URL,
    REDIRECT_URL: process.env.REACT_APP_REDIRECT_URL_DEV,
    PORT: 8080,
    CONTACTS_PAGE_SIZE: 15,
    MEETINGROOMS_PAGE_SIZE: 15,
    OTHERRESOURCES_PAGE_SIZE: 15,
    MEETINGROOMS_OVERVIEW_PAGE_SIZE: 10,
    MEETINGROOMS_OVERVIEW_NUMBER_EVENTS: 7,
    CONTACTS_EVENT_PAGE_SIZE: 10,
    START_UPDATE_TIME: '22:00',
    END_UPDATE_TIME: '06:00',
  },
  test: {
    API_URL: process.env.REACT_APP_API_URL,
    AUTH_URL: process.env.REACT_APP_AUTH_URL,
    REDIRECT_URL: process.env.REACT_APP_REDIRECT_URL_TEST,
    CONTACTS_PAGE_SIZE: 15,
    MEETINGROOMS_PAGE_SIZE: 15,
    OTHERRESOURCES_PAGE_SIZE: 15,
    MEETINGROOMS_OVERVIEW_PAGE_SIZE: 10,
    MEETINGROOMS_OVERVIEW_NUMBER_EVENTS: 7,
    CONTACTS_EVENT_PAGE_SIZE: 10,
    START_UPDATE_TIME: '22:00',
    END_UPDATE_TIME: '06:00',
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL,
    AUTH_URL: process.env.REACT_APP_AUTH_URL,
    REDIRECT_URL: process.env.REACT_APP_REDIRECT_URL_PROD,
    CONTACTS_PAGE_SIZE: 50,
    MEETINGROOMS_PAGE_SIZE: 50,
    OTHERRESOURCES_PAGE_SIZE: 50,
    MEETINGROOMS_OVERVIEW_PAGE_SIZE: 10,
    MEETINGROOMS_OVERVIEW_NUMBER_EVENTS: 7,
    CONTACTS_EVENT_PAGE_SIZE: 10,
    START_UPDATE_TIME: '22:00',
    END_UPDATE_TIME: '06:00',
  },
};

if (process.env.NODE_ENV === 'production') {
  module.exports = config.production;
} else if (process.env.NODE_ENV === 'test') {
  module.exports = config.test;
} else {
  module.exports = config.development;
}



//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 100
// module chunks = 0